import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectStatisticsApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-statistics'
    }



    /**
     * 项目情况统计
     * @param startTime
     * @param endTime
     * @returns
     */
    public projectDisplay(projectId) {
        return this.send({ projectId: projectId}, "projectDisplay", this.Methods.GET)
    }

    /**
     * 测试问题类型
     * @param startTime
     * @param endTime
     * @returns
     */
    public TestProblemStatistics(projectId) {
        return this.send({ projectId: projectId}, "TestProblemStatistics", this.Methods.GET)
    }

    
    public getQuestionWeek(projectId) {
        return this.send({ projectId: projectId}, "getQuestionWeek", this.Methods.GET)
    }
    public getQuestionStatus(projectId) {
        return this.send({ projectId: projectId}, "getQuestionStatus", this.Methods.GET)
    }
}
